export const HomeToSignConfirmationMap = {
    CONFIRM: 'CONFIRM',
    WAIVE: 'WAIVE',
    UNNECESSARY: 'UNNECESSARY',
    UNCONFIRMED: 'UNCONFIRMED',
};
export const OrdersEndpoint = (makeRequest) => {
    return {
        create(params, options) {
            return makeRequest('POST', '/v1/orders', params, options);
        },
        update(params, options) {
            return makeRequest('PUT', '/v1/orders', params, options);
        },
    };
};
//# sourceMappingURL=orders_endpoint.js.map